<div class="snackbar-container">
  <mat-icon class="icon">{{ data.icon }}</mat-icon>
  <span class="message">{{ data.message }}</span>
  @if (data.action) {
    <a mat-button class="action" (click)="onAction()">{{ data.action }}</a>
  }
</div>
